import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgParkeren = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <g clipPath="url(#Parkeren_svg__a)">
      <mask
        id="Parkeren_svg__b"
        width={18}
        height={26}
        x={11}
        y={7}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M22 18a2 2 0 0 1-2 2h-2v-4h2a2 2 0 0 1 2 2m7-11v26H11V7zm-4 11a5 5 0 0 0-5-5h-5v15h3v-5h2a5 5 0 0 0 5-5"
        />
      </mask>
      <g mask="url(#Parkeren_svg__b)">
        <path
          fill="#F18700"
          d="M20.66 29.32 8.41 22.25 15.48 10z"
        />
        <path
          fill="#F18700"
          d="m1.34 34.49 7.07-12.24 12.25 7.07z"
        />
        <path
          fill="#F7A941"
          d="M15.48 10 8.41 22.25l-12.24-7.07z"
        />
        <path
          fill="#F18700"
          d="m25.84 48.64-12.25-7.07 7.07-12.25z"
        />
        <path
          fill="#F18700"
          d="m20.66 29.32-7.07 12.25-12.25-7.08zM15.48 10 3.24 2.93l7.07-12.25z"
        />
        <path
          fill="#F7A941"
          d="M-3.83 15.18 3.24 2.93 15.48 10zM39.98 24.14l-12.25-7.07L34.8 4.82z"
        />
        <path
          fill="#F18700"
          d="m15.48 10 12.25 7.07-7.07 12.25z"
        />
        <path
          fill="#F7A941"
          d="m20.66 29.32 7.07-12.25 12.25 7.07z"
        />
        <path
          fill="#F18700"
          d="m34.8 4.82-7.07 12.25L15.48 10z"
        />
        <path
          fill="#F7A941"
          d="m20.66 29.32 12.25 7.07-7.07 12.25z"
        />
        <path
          fill="#F7A941"
          d="m39.98 24.14-7.07 12.25-12.25-7.07z"
        />
        <path
          fill="#F18700"
          d="m10.31-9.32 12.25 7.07L15.48 10z"
        />
        <path
          fill="#F18700"
          d="m15.48 10 7.08-12.25L34.8 4.82z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="Parkeren_svg__a">
        <path
          fill="#fff"
          d="M0 0h40v40H0z"
        />
      </clipPath>
    </defs>
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgParkeren);

export default ForwardRef;
